/* 🤖 this file was generated by svg-to-ts */
export const mgcIconLeftSmallFilled: {
  name: 'left-small-filled';
  data: string;
} = {
  name: 'left-small-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12.8 8.197a1.364 1.364 0 0 0-.28.1c-.217.111-3.133 3.046-3.242 3.263a1.087 1.087 0 0 0 0 .88c.126.251 3.031 3.156 3.282 3.282a.996.996 0 0 0 1.146-.208c.294-.314.274-.06.274-3.514 0-2.947-.004-3.107-.074-3.24-.227-.426-.671-.652-1.106-.563"/></svg>`
};
